module.exports = __webpack_public_path__ + "static/media/notificationWarning.0a7a78fb.svg";